import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CollapsibleGroupComponent } from './collapsible-group/collapsible-group.component';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { DateRangeComponent } from './components/date-range/date-range.component';
import { AutofocusDirective } from './directives/autofocus.directive';
import { ConfirmationDialogComponent } from './components/confirmation/confirmation-dialog.component';
import { FileUploadDialogComponent } from './components/file-upload-dialog/file-upload-dialog.component';
import {RouterModule} from "@angular/router";
import {FormsModule, ReactiveFormsModule} from "@angular/forms";
import { NgPipesModule } from 'ngx-pipes';
import { AlertComponent } from './components/alert/alert.component';
import { FilterOutPipe } from './filter-out.pipe';
import { PasswordRequirementsComponent } from './password-requirements/password-requirements.component';
import { DisableWhenClickedDirective } from './directives/disable-when-clicked.directive';



@NgModule({
  declarations: [
    CollapsibleGroupComponent,
    DateRangeComponent,
    AutofocusDirective,
    ConfirmationDialogComponent,
    FileUploadDialogComponent,
    AlertComponent,
    FilterOutPipe,
    PasswordRequirementsComponent,
    DisableWhenClickedDirective
  ],
  imports: [
    CommonModule,
    RouterModule,
    FormsModule,
    ReactiveFormsModule,
    NgbModule,
    NgPipesModule

  ],
  exports: [
    CollapsibleGroupComponent,
    DateRangeComponent,
    AutofocusDirective,
    FileUploadDialogComponent,
    NgPipesModule,
    AlertComponent,
    FilterOutPipe,
    PasswordRequirementsComponent,
    DisableWhenClickedDirective
  ]
})
export class SharedModule { }
